import React, { lazy } from 'react'
import { Route, Switch,Redirect } from "react-router-dom";
const LoginPage = lazy(() => import("user/LoginPage"));
const CompanyRegisterValidation = lazy(() => import("user/CompanyRegisterValidation"));
const UserRegisterValidation = lazy(() => import("user/UserRegisterValidation"));
const UserRequestPassword = lazy(() => import("user/UserRequestPassword"));
const UserResetPassword = lazy(() => import("user/UserResetPassword"));

function AuthREgisterRoutes() {
  return (
    <Switch>
      <Route path="/login" component={LoginPage} />
      <Route path="/company-register-validation/:token" component={CompanyRegisterValidation} />
      <Route path="/user-register-validation/:token" component={UserRegisterValidation} />
      <Route path="/user-forgot-password" component={UserRequestPassword} />
      <Route path="/user-reset-password/:token" component={UserResetPassword} />
      <Route exact path="/" component={LoginPage} />
      {/* <Route exact path="*" component={()=><Redirect to="/login" />} /> */}
    </Switch>
  )
}

export default AuthREgisterRoutes
